import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '../themes/App'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('themes')
  if (container) {
    const root = ReactDOM.createRoot(container)
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    )
  }
})
